// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";
import Requests from ".";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## EmployeeTracking Get
/**
 *
 * @param {{params: object, query: { searchKey: string, regionId: string, companyId: string, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.EmployeeTracking.GetAll(option));

  const version = localStorage.getItem("version");

  if (version === "v1" && response.message === "OK") {
    response.data.items = response.data.items.map((item) => ({
      ...item,
      fullname: item.name + " " + item.surname,
    }));
  }

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## EmployeeTracking Create
/**
 *
 * @param {{ fullName: string, phoneNo: string, email: string, regionId: string, image: File, workStartTime: number, workEndTime: number  }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const version = localStorage.getItem("version");
  if (version === "v1") return await Requests.v1.EmployeeTracking.Create(form);

  const response = await $api.post(Endpoints.EmployeeTracking.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## EmployeeTracking Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.EmployeeTracking.GetById(option));

  const version = localStorage.getItem("version");

  if (version === "v1" && response.message === "OK") {
    const data = response.data || null;
    if (data)
      response.data = {
        ...response.data,
        fullname: response.data.name + " " + response.data.surname,
      };
  }

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## EmployeeTracking Update
/**
 *
 * @param {{ fullName: string, phoneNo: string, email: string, regionId: string, image: File, workStartTime: number, workEndTime: number , isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const version = localStorage.getItem("version");
  if (version === "v1")
    return await Requests.v1.EmployeeTracking.Update(form, option);

  const response = await $api.put(
    Endpoints.EmployeeTracking.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## EmployeeTracking Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.EmployeeTracking.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## EmployeeTracking Current Location
/**
 *
 * @param {{params: object, query: {employeeId: string}}} option
 *
 * @returns
 */
export const CurrentLocation = async (option) => {
  const response = await $api.get(
    Endpoints.EmployeeTracking.CurrentLocation(option)
  );
  return response;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  CurrentLocation,
};
